import { agentsRequest } from '@/services/request';

export enum CloudInstanceAction {
  Start = 'start',
  Stop = 'stop',
}

/**
 * 启动/停止 Wegic Cloud 实例
 */
export function operateCloudInstance(projectId: string, action: CloudInstanceAction) {
  return agentsRequest.post(`/projects/v1/${projectId}/database/instance/operation`, { action }, {
    hideHTTPErrorMessage: true,
    hideCodeErrorMessage: true,
  });
}

/**
 * 获取项目数据库配置
 */
export async function getDatabaseConfig(projectId: string) {
  return agentsRequest.get(`/projects/v1/${projectId}/database/config`, {
    allowedCodes: [1],
    hideCodeErrorMessage: true,
  });
}

/**
 * 获取项目所有数据库表
 */
export async function getDatabaseTables(projectId: string) {
  return agentsRequest.get(`/projects/v1/${projectId}/database/tables`);
}

/**
 * 获取表结构
 */
export async function getDatabaseTableStructure(projectId: string, tableName: string) {
  return agentsRequest.get(`/projects/v1/${projectId}/database/tables/${tableName}`);
}

/**
 * 查询表数据
 */
export async function queryDatabaseTableData(
  projectId: string,
  tableName: string,
  params?: Record<string, unknown>,
) {
  return agentsRequest.post(`/projects/v1/${projectId}/database/tables/${tableName}/query`, params);
}
